import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AngularDatasModule, AuthService } from '@univacity/angular/datas';
import { AngularUiModule } from '@univacity/angular/ui';
import { RoutePath } from '@univacity/shared/types';
import { MessagesFacade } from '../../../+state/messages/messages.facade';
import { MessageThreadCardComponent } from '../message-thread-card/message-thread-card.component';
import { MessageThreadsFiltersComponent } from '../message-threads-filters/message-threads-filters.component';

@Component({
  selector: 'un-message-thread-list',
  imports: [
    CommonModule,
    MessageThreadCardComponent,
    MessageThreadsFiltersComponent,
    AngularUiModule,
    AngularDatasModule,
    NgOptimizedImage,
    RouterModule,
  ],
  templateUrl: './message-thread-list.component.html',
  styleUrls: ['./message-thread-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageThreadListComponent implements OnInit {
  @Input() hideProfile: boolean;
  RoutePath = RoutePath;
  constructor(public auth: AuthService, public facade: MessagesFacade) {}

  ngOnInit(): void {
    this.facade.fetchThread();
  }
}
